// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import BarsOutlinedSvg from "@ant-design/icons-svg/lib/asn/BarsOutlined";
import AntdIcon from "../components/AntdIcon";
const BarsOutlined = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: BarsOutlinedSvg
    });
if (process.env.NODE_ENV !== "production") {
    BarsOutlined.displayName = "BarsOutlined";
}
export default /*#__PURE__*/ React.forwardRef(BarsOutlined);
